import { BreakdownHistoryChart } from "src/components/__pageComponents/NetWorthPage/charts/BreakdownHistoryChart";
import {
  useAllocationHistory,
  useGlobalCurrency,
  useStructureGrouping,
} from "@iliotech/data-wire";
import { useParams } from "react-router-dom";
import { mapAllocationDataToTimeSeriesItems } from "@iliotech/data-wire/src/processing/breakdown";
import React from "react";
import moment from "moment";
import { ReportWidgetProps } from "../../ReportWidgetProps";
export const NetWorthBreakdownWidget = ({
  height,
  width,
  isHalfHeight,
  structureContext,
  periodContext,
}: ReportWidgetProps) => {
  const { portfolioId } = useParams<{ portfolioId: string }>();
  const { data: allocationHistory } = useAllocationHistory(
    portfolioId!,
    periodContext
  );
  const { currencyFormatter } = useGlobalCurrency();

  const { grouping } = structureContext || useStructureGrouping();
  const daysRange = React.useMemo(() => {
    if (!allocationHistory?.data?.length) return 1;
    const sortedDates = allocationHistory?.data?.sort((a, b) =>
      moment(a.date).isBefore(b.date) ? -1 : 1
    );

    const maxDate = sortedDates[sortedDates.length - 1]!.date;
    const minDate = sortedDates[0]!.date;

    return moment(maxDate).diff(moment(minDate), "days");
  }, [allocationHistory]);

  const { timeSeriesData, legendItems } = mapAllocationDataToTimeSeriesItems(
    allocationHistory?.data,
    grouping,
    currencyFormatter
  );

  return (
    <BreakdownHistoryChart
      isPdf
      timeSeriesData={timeSeriesData}
      currencyFormatter={currencyFormatter}
      daysRange={daysRange}
      breakdownTotals={legendItems}
      height={height}
      width={width}
      periodOverride={periodContext}
      isHalfHeight={isHalfHeight}
    />
  );
};
